export default {
	'user_table_': '',
	'user_filter_fname': 'First Name',
	'user_filter_lname': 'Last Name',
	'user_filter_created_at': 'Creation Date',
	'user_filter_phone': 'Phone',
	'user_filter_email': 'E-mail',
	'user_filter_status': 'Status',
	'user_filter_role': 'Role',
	'user_table_nameSurname': 'Name',
	'user_table_id': 'ID',
	'user_table_created_at': 'Created',
	'user_table_email': 'E-mail',
	'user_table_phone': 'Phone',
	'user_table_status': 'Status',
	'user_table_role_id': 'Role',
	'user_table_edit': 'Edit',

	'user_validate_required' : 'Field must be filled',
	'user_validate_name_length' : 'The field should have a minimum of 2 and a maximum of 30 characters',
	'user_validate_regexp_name' : 'Allowed characters include Latin letters, as well as hyphens and apostrophes',
	'user_validate_phone_max_length' : 'The phone number cannot exceed 18 characters',
	'user_validate_phone_min_length' : 'The phone number must be at least 10 characters long',
	'user_validate_email_max_length' : 'The email address cannot exceed 80 characters',
	'user_validate_email_min_length' : 'The email address should be at least 7 characters long',
	'user_validate_regexp_password' : 'The password should be 8-30 characters long and include uppercase and lowercase Latin letters, numbers, and symbols. Acceptable symbols include ! @ # $ % ^ & * () ; "\' _ - . ,".',

	'user_create_title': 'Create a new user',
	'user_edit_title': 'Editing a user',

	'user_edit_fname': 'First Name',
	'user_edit_lname': 'Last Name',
	'user_edit_phone': 'Phone',
	'user_edit_email': 'E-mail',
	'user_edit_role': 'Role',
	'user_edit_status': 'Status',
	'user_edit_password': 'Password',
	'user_edit_generate_password': 'Generate a random password',
	'user_edit_copy_password': 'Copy the password to the clipboard',
	'user_edit_btn_save': 'Save',
	'user_edit_btn_cancel': 'Cancel',

	'user_create_btn': 'Create a user'
};